import { useCallback, useEffect, useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { FacetFields, SearchParams } from '@yme/utils/bloomreach';
import { buildFacets } from './helpers';
export const useFacetsFilter = ({ initiaLFacets, query, category, sort, callback, }) => {
    const [buildedFacets, setBuildedFacets] = useState(buildFacets(initiaLFacets));
    const [isDiscountActive, setIsDiscountActive] = useState(false);
    const history = useHistory();
    const isSomeFacetsSelected = useMemo(() => buildedFacets.some((facet) => facet.values.some((value) => value.checked)), [buildedFacets]);
    const selectedFacets = useMemo(() => buildedFacets.filter((facet) => facet.values.some((value) => value.checked)), [buildedFacets]);
    useEffect(() => {
        const queryParams = new URLSearchParams(history.location.search);
        if (initiaLFacets.length) {
            const mappedFacets = initiaLFacets.map((facet) => {
                return {
                    ...facet,
                    activeOptions: queryParams.get(facet.name)?.split(',') ?? [],
                };
            });
            setBuildedFacets(buildFacets(mappedFacets));
        }
        const isDiscounted = queryParams.get(FacetFields.IS_DISCOUNTED);
        setIsDiscountActive(Boolean(isDiscounted));
    }, [history.location.search, initiaLFacets]);
    const handleSelectOption = useCallback((facetName) => (options) => {
        const queryParams = new URLSearchParams(history.location.search);
        const activeOptions = options.filter((option) => option.checked);
        if (activeOptions.length) {
            const activeOptionsNames = activeOptions.map((option) => option.value).join(',');
            queryParams.set(facetName, activeOptionsNames);
        }
        else {
            queryParams.delete(facetName);
        }
        history.push({
            search: queryParams.toString(),
        });
        if (callback) {
            callback();
        }
    }, [callback, history]);
    const handleFilterToggle = useCallback((checked) => {
        handleSelectOption(FacetFields.IS_DISCOUNTED)([
            {
                checked,
                value: checked ? '1' : '',
                label: '',
            },
        ]);
    }, [handleSelectOption]);
    const handleClearFilters = useCallback(() => {
        const queryParams = new URLSearchParams();
        queryParams.set(SearchParams.QUERY, query);
        queryParams.set(SearchParams.CATEGORY, category);
        if (sort) {
            queryParams.set(SearchParams.SORT, sort);
        }
        history.push({
            search: queryParams.toString(),
        });
        if (callback) {
            callback();
        }
    }, [callback, category, history, query, sort]);
    return {
        isDiscountActive,
        isSomeFacetsSelected,
        buildedFacets,
        selectedFacets,
        handleSelectOption,
        handleFilterToggle,
        handleClearFilters,
    };
};
